@reference "@glow/tailwind-config/reference.css";

.input {
  @apply appearance-none;
  @apply block;
  @apply p-3;
  @apply w-full;
  @apply rounded-sm;
  @apply border;
  @apply border-solid;
  @apply text-sm;
  @apply bg-theme-surface;
  @apply border-gray-300;
  @apply border-solid;
  @apply h-10;
}

.input::-webkit-calendar-picker-indicator {
  background: none;
}

.disabled {
  @apply opacity-30;
}

input.input[type="time"] {
  @apply pt-0;
  @apply pb-0;
}

textarea.input {
  @apply h-24;
}

select.input {
  @apply pr-8;
}

.input.hasLeftIcon {
  @apply pl-10;
}

.input.hasRightIcon {
  @apply pr-9;
}

.input:focus {
  @apply outline-hidden;
  @apply border-primary-500;
  @apply text-emphasis-high;
}

.input[aria-invalid="true"] {
  @apply border-red-700;
}
.leftIcon,
.rightIcon {
  @apply block;
  @apply grid;
  @apply items-center;
  @apply justify-center;
  @apply absolute;
  @apply top-0;
  @apply left-2;
  @apply bottom-0;
  @apply rounded-sm;
  @apply h-7;
  @apply w-7;
  @apply my-auto;
}

.leftIcon {
  @apply text-emphasis-extra;
}

.rightIcon {
  @apply text-emphasis-medium;
}

.leftIcon svg,
.rightIcon svg {
  @apply pointer-events-none;
  @apply text-base;
}

.rightIcon {
  @apply left-auto;
  @apply right-2;
}

button.rightIcon {
  @apply cursor-pointer;
}

button.rightIcon:hover {
  @apply bg-gray-100;
}

.label {
  @apply block;
  @apply relative;
  @apply w-full;
  @apply bg-transparent;
}

.label .labelText {
  @apply text-xs;
  @apply pointer-events-none;
  @apply truncate;
}

.label .labelText.focus {
  @apply text-emphasis-extra;
}

.label .labelText.hasError {
  @apply text-red-700;
}

.label .labelText.bold {
  @apply font-bold;
  @apply text-emphasis-high;
}

.label .labelText.bold.focus {
  @apply text-emphasis-extra;
}

.label .labelText.bold.hasError {
  @apply text-red-700;
}

.label .labelText {
  @apply text-gray-500;
}

div.descriptionText {
  @apply text-xs;
  @apply mb-1;
  @apply text-gray-500;
}
